// Tracks whether window.opener has been closed, reactively.
// Provides: data.openerClosed (bool)
// Components use this in their own canClose / closeable computed.
export default {
    data() {
        return {
            openerClosed: false
        };
    },
    mounted() {
        if (window.opener) {
            this._openerPoll = setInterval(() => {
                if (!window.opener || window.opener.closed) {
                    this.openerClosed = true;
                    clearInterval(this._openerPoll);
                }
            }, 500);
        }
    },
    unmounted() {
        clearInterval(this._openerPoll);
    }
};
